<div class="background">
    <div id="pageContent" class="contentWrapper">
        <yasc-navigation [inputRest]="restApi"
                         [menuItemList]="menuItems"
                         [navigationStyle]="NavigationStyle.Sidenav"
                         [permissions]="this.runtimeCache.userRights.permissions">
            <div header-content
                 style="display: flex; align-items: center; gap: 12px; width: 100%; max-width: 100%; min-width: 0; box-sizing: border-box; flex: 1 1 auto;">
                <yasc-logo style="display: block; height: 64px; aspect-ratio: 1; flex: 0 0 auto;"></yasc-logo>

                <div style="display: flex; align-items: center; justify-content: flex-end; margin-left: auto; min-width: 0; flex: 0 1 auto;">
                    <yasc-accessibility yascType="iconButton"></yasc-accessibility>

                    <div *ngIf="fibuModuleActive()" style="display: flex; align-items: center; flex: 0 1 auto; min-width: 0; scale: 85%; transform-origin: right center;">
                        <mat-form-field class="compact-form-field" appearance="outline"
                                        style="margin-bottom: -1.25em; max-width: 150px" color="accent">
                            <mat-label>{{ 'fibuFinancialYear' | translate: locale.language }}</mat-label>
                            <mat-select (valueChange)="this.bookingController.bookingYearChanged($event)"
                                        [value]="this.restApi.v0.fibu.bookingYear()">
                                <mat-option *ngFor="let year of financialYears" [value]="year.value">
                                    {{ year.name }}
                                </mat-option>
                            </mat-select>
                        </mat-form-field>

                        <mat-form-field appearance="outline"
                                        style="margin-bottom: -1.25em; margin-left: 10px; max-width: 200px"
                                        color="accent">
                            <mat-label>{{ 'fibuFinancialMonth' | translate: locale.language }}</mat-label>
                            <mat-select (valueChange)="this.bookingController.bookingMonthChanged($event)"
                                        [value]="this.restApi.v0.fibu.bookingMonth()">
                                <mat-option *ngFor="let month of monthNames" [value]="month.value">
                                    {{ month.name }}
                                </mat-option>
                            </mat-select>
                        </mat-form-field>
                    </div>

                    <button
                            mat-icon-button
                            style="margin-right: 5px;"
                            (click)="openBugTicket()"
                            [disabled]="runtimeCache.ongoingBugScreenshot"
                            [class.bug-pulse]="runtimeCache.ongoingBugScreenshot"
                            matTooltip="{{ runtimeCache.ongoingBugScreenshot
                                    ? 'Screenshot wird erstellt'
                                    : ('CTRLB' | translate:locale.language) }}">
                        <mat-icon style="color: var(--yasc-tertiary-light)">
                            bug_report
                        </mat-icon>
                    </button>

                    <button mat-icon-button style="margin-right: 5px;color: var(--yasc-tertiary-light)"
                            [class.ripple]="timeClock.isTimerRunning"
                            (click)="openTimeClock()" matTooltip="{{'CTRLO'|translate:locale.language}}">
                        <mat-icon style="color: var(--yasc-tertiary-light)">alarm</mat-icon>
                    </button>

                    <cp-notification-center style="flex: 0 0 auto;"></cp-notification-center>

                    <cp-active-user-info
                            style="display: flex; align-items: center; justify-content: flex-end; flex: 0 0 auto; max-width: 250px; min-width: 0;"
                            (shortcut)="openShortcut($event)">
                    </cp-active-user-info>
                </div>
            </div>

            <div class="content">
                <router-outlet></router-outlet>
            </div>
        </yasc-navigation>
    </div>
</div>